// BARCI: revela cada seccion con fade + subida leve cuando entra en pantalla.
document.documentElement.classList.add('js-animations');

var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (!reduceMotion && 'IntersectionObserver' in window) {
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  var reveal = function () {
    var sections = document.querySelectorAll('#MainContent > .shopify-section:not(.animate-skip)');
    sections.forEach(function (section) {
      observer.observe(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }

  // Secciones que un app o el theme editor inyecten despues (ej. render dinamico).
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.shopify-section') || event.target;
    if (section && section.closest('#MainContent')) {
      section.classList.add('is-inview');
    }
  });
}
